import { doGet } from 'api/request';
import type {
  BalanceLogResponse,
  BalanceOnlyResponse,
} from 'api/resources/balance/types';
import { LOGGER_TYPE } from 'api/types';

export const getBalance = (accountId: string) => {
  return doGet<BalanceOnlyResponse>(
    `accounts/${accountId}/balance`,
    LOGGER_TYPE.JUPITER,
    {
      params: { balance_only: 'true' },
    },
  );
};

// TODO: NEED TO UPDATE ONCE BE IS READY WITH THE LIMIT / QUERY STRING etc
export const getBalanceLog = (accountId: string) => {
  return doGet<BalanceLogResponse>(
    `accounts/${accountId}/balance`,
    LOGGER_TYPE.JUPITER,
  );
};
